<template>
  <div name="hres7de-detail">
    <div  class="box">
      <div class="box-body">
        <div class="detail detail-responsive">

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['10'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ setYearOutput(searchIndex.year) }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['20'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.name }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7DEP1']['30'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.numclseq }}</div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion">

        <detail-tab1 :labels="labels"
                     :labelsButton="labelsButton"
                     :nowLang="nowLang"
                     :detailTab1="detail.tab1"
                     :detailTab1PopupBtn1to3Columns="detailTab1PopupBtn1to3Columns"
                     :detailTab1PopupBtn4Columns="detailTab1PopupBtn4Columns"
                     :detailTab1Popup="detailTab1Popup"
                     :receivedHres7deDetailTab1Popup="receivedHres7deDetailTab1Popup"/>
        <detail-tab2 :labels="labels"
                     :labelsButton="labelsButton"
                     :codeval="codeval"
                     :detailTab2="detail.tab2"
                     :postHres7deTab2Save="postHres7deTab2Save"
                     :indexSelected="indexSelected"
                     :searchIndex="searchIndex"
                     :searchDetail="searchDetail" />
        <detail-tab3 :labels="labels"
                     :nowLang="nowLang"
                     :labelsButton="labelsButton"
                     :codeval="codeval"
                     :detailTab3="detail.tab3"
                     :detailTab3MaxRowspan="detailTab3MaxRowspan"
                     :detailTab3Columns="detailTab3Columns"
                     :detailTab3Selected="detailTab3Selected"
                     :setDetailTab3Selected="setDetailTab3Selected"
                     :detailTab3Popup="detailTab3Popup"
                     :receivedHres7deDetailTab3Popup="receivedHres7deDetailTab3Popup"
                     :searchIndex="searchIndex"
                     :indexSelected="indexSelected"
                     :postHres7deTab3PopupSave="postHres7deTab3PopupSave"
                     :searchDetail="searchDetail" />

        <detail-tab4 :labels="labels"
                     :labelsButton="labelsButton"
                     :detailTab4="detail.tab4"
                     :searchIndex="searchIndex"
                     :indexSelected="indexSelected"
                     :postHres7deTab4Save="postHres7deTab4Save"
                     :searchDetail="searchDetail" />


        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import detailTab1 from 'components/hres7de/detailTab1'
import detailTab2 from 'components/hres7de/detailTab2'
import detailTab3 from 'components/hres7de/detailTab3'
import detailTab4 from 'components/hres7de/detailTab4'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres7de-detail',
  props: [ 'labels',
    'labelsButton',
    'nowLang',
    'toggle',
    'codeval',
    'descCodeval',
    'indexSelected',
    'searchIndex',
    'detail',
    'detailTab1PopupBtn1to3Columns',
    'detailTab1PopupBtn4Columns',
    'detailTab1Popup',
    'receivedHres7deDetailTab1Popup',
    'detailTab3MaxRowspan',
    'detailTab3Columns',
    'detailTab3Selected',
    'setDetailTab3Selected',
    'detailTab3Popup',
    'receivedHres7deDetailTab3Popup',
    'postHres7deTab2Save',
    'postHres7deTab3PopupSave',
    'postHres7deTab4Save',
    'searchDetail'
  ],
  methods: {
    setYearOutput (year) {
      return assetsUtils.getYearOutput(year)
    }
  },
  components: {
    detailTab1,
    detailTab2,
    detailTab3,
    detailTab4
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?370e7ad9